import type { Options } from 'highcharts';
import {
  body2,
  button,
  caption,
  colors,
  fontSizes,
  fontWeights,
  highchartColorPalette,
  spacing,
} from 'ui/theme';
import { MONITOR_CARD_HEIGHT } from './experimentMonitorCards';

export const timeSeriesChartOptions: Options = {
  chart: {
    style: {
      fontFamily: 'Sofia Pro',
    },
    type: 'line',
    spacingTop: 30,
    spacingBottom: 20,
    height: MONITOR_CARD_HEIGHT.VARIANT_PERFORMANCE_CHART,
  },
  title: {
    text: undefined,
  },
  exporting: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  colors: highchartColorPalette,
  xAxis: {
    type: 'datetime',
    dateTimeLabelFormats: {
      minute: '%l:%M%P',
      hour: '%l:%M%P', // 1:05pm
      day: '%a, %b %e', // Fri, Sep 21
    },
    labels: {
      style: {
        ...body2,
        fontSize: 'inherit',
        fontWeight: '400',
        color: colors.textSecondary,
      },
    },
  },
  yAxis: {
    lineWidth: 1,
    type: 'linear',
    gridLineDashStyle: 'ShortDash',
    gridLineWidth: 1,
    endOnTick: false,
    lineColor: colors.grey15,
    gridLineColor: colors.grey15,
    title: {
      margin: 30,
      style: {
        ...caption,
        fontWeight: '400',
        color: colors.textSecondary,
      },
    },
    labels: {
      style: {
        ...button,
        fontSize: 'inherit',
        fontWeight: '500',
        color: colors.grey50,
      },
    },
  },
  tooltip: {
    headerFormat: '',
    outside: true,
    shared: false,
    useHTML: true,
    padding: 0,
    borderRadius: 10,
    borderColor: colors.grey80,
    backgroundColor: colors.grey80,
    style: {
      color: colors.white,
      fontSize: fontSizes.s12,
    },
  },
};

export const TOOLTIP_STYLES = {
  wrapperTypography: `font-family: 'Sofia Pro'; font-weight: ${caption.fontWeight}; font-size: ${caption.fontSize}; color: ${colors.white}; letter-spacing: ${caption.letterSpacing};`,
  wrapperAlignment: `display:flex; gap: ${spacing.half}; padding: ${spacing.quarter} ${spacing.half};`,
  primaryValueTypography: `font-weight: ${fontWeights.bold};`,
  categoryAlignment:
    'max-width: 250px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;',
  secondaryValueTypography: `color: ${colors.grey25};`,
};
